module.exports = __webpack_public_path__ + "static/media/neighbourhood.50cb8c8a.jpg";